import React, { useState } from 'react';
import { ChevronRight, ChevronDown, LayoutDashboard, List, Radio, User, BarChart3, LineChart, Calendar, Database, FileText, Settings, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate, useLocation } from 'react-router-dom';

export const SidebarOption2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [ibExpanded, setIbExpanded] = useState(true);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="w-64 h-screen bg-[#141416] border-r border-[#2A2A2E] flex flex-col overflow-y-auto">
      <div className="p-6 border-b border-[#2A2A2E]">
        <img 
          src="https://customer-assets.emergentagent.com/job_channel-crm-system/artifacts/4egfgzp6_ua%20logo.png" 
          alt="Underads" 
          className="h-8"
        />
      </div>

      <nav className="flex-1 p-4 space-y-2">
        <Button
          variant="ghost"
          className="w-full justify-start text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
          onClick={() => navigate('/dashboard')}
        >
          <LayoutDashboard size={20} className="mr-3" />
          Dashboard
        </Button>

        <div>
          <Button
            variant="ghost"
            className="w-full justify-start bg-[#E63946]/10 text-[#E63946] hover:bg-[#E63946]/20 hover:text-[#E63946]"
            onClick={() => setIbExpanded(!ibExpanded)}
          >
            <List size={20} className="mr-3" />
            IB Management
            {ibExpanded ? <ChevronDown size={16} className="ml-auto" /> : <ChevronRight size={16} className="ml-auto" />}
          </Button>

          {ibExpanded && (
            <div className="ml-4 mt-2 space-y-1 border-l-2 border-[#2A2A2E] pl-2">
              <Button
                variant="ghost"
                size="sm"
                className="w-full justify-start text-xs text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
                onClick={() => navigate('/prototype-option2')}
              >
                Overview (All IB)
              </Button>
              
              <div className="ml-2">
                <p className="text-xs text-[#6C757D] px-2 py-1">List of IB:</p>
                
                <Button
                  variant="ghost"
                  size="sm"
                  className="w-full justify-start text-xs text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
                >
                  <User size={14} className="mr-2" />
                  Channel Profile
                </Button>
                
                <Button
                  variant="ghost"
                  size="sm"
                  className="w-full justify-start text-xs text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
                >
                  <Radio size={14} className="mr-2" />
                  Channel Overview
                </Button>
                
                <Button
                  variant="ghost"
                  size="sm"
                  className="w-full justify-start text-xs text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
                >
                  <BarChart3 size={14} className="mr-2" />
                  Channel Performance
                </Button>
                
                <Button
                  variant="ghost"
                  size="sm"
                  className="w-full justify-start text-xs text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
                >
                  <LineChart size={14} className="mr-2" />
                  Channel Analytic
                </Button>
                
                <Button
                  variant="ghost"
                  size="sm"
                  className="w-full justify-start text-xs text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
                >
                  <Calendar size={14} className="mr-2" />
                  Channel Activity
                </Button>
                
                <Button
                  variant="ghost"
                  size="sm"
                  className="w-full justify-start text-xs text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
                >
                  <FileText size={14} className="mr-2" />
                  Channel Campaign
                </Button>
                
                <Button
                  variant="ghost"
                  size="sm"
                  className="w-full justify-start text-xs text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
                >
                  <Database size={14} className="mr-2" />
                  Daily Data
                </Button>
                
                <Button
                  variant="ghost"
                  size="sm"
                  className="w-full justify-start text-xs text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
                >
                  <Database size={14} className="mr-2" />
                  Database Segmentation
                </Button>
                
                <Button
                  variant="ghost"
                  size="sm"
                  className="w-full justify-start text-xs text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
                >
                  <FileText size={14} className="mr-2" />
                  Log
                </Button>
              </div>

              <Button
                variant="ghost"
                size="sm"
                className="w-full justify-start text-xs text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
              >
                List of Campaign
              </Button>
            </div>
          )}
        </div>

        <Button
          variant="ghost"
          className="w-full justify-start text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
        >
          <Settings size={20} className="mr-3" />
          Settings
        </Button>
      </nav>

      <div className="p-4 border-t border-[#2A2A2E]">
        <Button
          variant="ghost"
          className="w-full justify-start text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
          onClick={handleLogout}
        >
          <LogOut size={20} className="mr-3" />
          Logout
        </Button>
      </div>
    </div>
  );
};

export default function PrototypeOption2() {
  return (
    <div className="flex min-h-screen bg-[#0A0A0B] text-[#F8F9FA]">
      <SidebarOption2 />
      <div className="flex-1 px-4 md:px-6 lg:px-8 py-6 md:py-8">
        <div className="border border-[#E63946] bg-[#E63946]/5 rounded-lg p-6 mb-6">
          <h2 className="text-xl font-semibold text-[#E63946] mb-2">✨ OPTION 2: NESTED SIDEBAR MENU</h2>
          <p className="text-[#ADB5BD]">Semua sub-modules ada dalam sidebar - expand/collapse untuk navigate</p>
        </div>

        <div className="mb-6">
          <h1 className="text-4xl font-bold font-heading text-[#F8F9FA]">
            Channel Overview
          </h1>
          <p className="text-[#ADB5BD]">Content untuk selected sub-module</p>
        </div>

        <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8 mb-6">
          <h3 className="text-2xl font-semibold mb-4">Selected: Channel Overview</h3>
          <p className="text-[#ADB5BD] mb-6">Klik menu di sidebar untuk switch ke sub-module lain</p>
          
          <div className="grid grid-cols-4 gap-4">
            <div className="border border-[#2A2A2E] rounded p-4">
              <p className="text-xs text-[#ADB5BD]">Commission</p>
              <p className="text-2xl font-mono text-[#F8F9FA]">MYR 1,288</p>
            </div>
            <div className="border border-[#2A2A2E] rounded p-4">
              <p className="text-xs text-[#ADB5BD]">Traded Lot</p>
              <p className="text-2xl font-mono text-[#F8F9FA]">116.87</p>
            </div>
            <div className="border border-[#2A2A2E] rounded p-4">
              <p className="text-xs text-[#ADB5BD]">Active Client</p>
              <p className="text-2xl font-mono text-[#F8F9FA]">373</p>
            </div>
            <div className="border border-[#2A2A2E] rounded p-4">
              <p className="text-xs text-[#ADB5BD]">Deposit</p>
              <p className="text-2xl font-mono text-[#F8F9FA]">MYR 44k</p>
            </div>
          </div>
        </div>

        <div className="border border-[#06D6A0] bg-[#06D6A0]/5 rounded-lg p-6 mb-4">
          <h3 className="text-lg font-semibold text-[#06D6A0] mb-2">✅ KELEBIHAN OPTION 2:</h3>
          <ul className="text-[#ADB5BD] space-y-1 ml-4">
            <li>• Navigation always visible - tahu kat mana sekarang</li>
            <li>• Quick access ke any sub-module tanpa perlu back</li>
            <li>• Good for complex multi-level navigation</li>
            <li>• Familiar pattern (macam file explorer)</li>
          </ul>
        </div>

        <div className="border border-[#E63946] bg-[#E63946]/5 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-[#E63946] mb-2">❌ KEKURANGAN OPTION 2:</h3>
          <ul className="text-[#ADB5BD] space-y-1 ml-4">
            <li>• Sidebar jadi panjang & crowded</li>
            <li>• Perlu scroll sidebar kalau banyak menu</li>
            <li>• Mobile view susah (sidebar ambik space)</li>
            <li>• Need to select IB first (extra step)</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
